import { render, staticRenderFns } from "./AllowanceIncrementMonitor.vue?vue&type=template&id=248a34e7"
import script from "./AllowanceIncrementMonitor.vue?vue&type=script&lang=js"
export * from "./AllowanceIncrementMonitor.vue?vue&type=script&lang=js"
import style0 from "./AllowanceIncrementMonitor.vue?vue&type=style&index=0&id=248a34e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports